import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import EmptyStateScreen from 'shared/patterns/vxl/EmptyStateScreen/EmptyStateScreen';
import theme from 'shared/styles/theme';

type EmptyStateVariant = 'activeOffers' | 'pendingOffers';

interface OffersEmptyStateProps {
  variant: EmptyStateVariant;
}

const emptyStateConfig: Record<
  EmptyStateVariant,
  {
    headlineKey: string;
    bodyKey: string;
    illustrationKey: 'OFFERS_B' | 'BINOCULARS_A';
  }
> = {
  activeOffers: {
    headlineKey: 'noActiveOffersTitle',
    bodyKey: 'footerMessage',
    illustrationKey: 'OFFERS_B',
  },
  pendingOffers: {
    headlineKey: 'noPendingOffersTitle',
    bodyKey: 'noPendingOffersMessage',
    illustrationKey: 'BINOCULARS_A',
  },
};

const OffersEmptyState = ({ variant }: OffersEmptyStateProps) => {
  const { t: translatedText } = useTranslation('rewards', {
    keyPrefix: 'myOffers',
  });
  const config = emptyStateConfig[variant];

  return (
    <View style={styles.container}>
      <EmptyStateScreen
        headlineText={translatedText(config.headlineKey)}
        content={
          <BodySmText style={styles.subtitle} numberOfLines={1}>
            {translatedText(config.bodyKey)}
          </BodySmText>
        }
        illustrationKey={config.illustrationKey}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: theme.spacing.s,
    paddingBottom: theme.spacing.s,
  },
  subtitle: {
    color: theme.color.text.secondary,
    textAlign: 'center',
  },
});

export default OffersEmptyState;
